<template>
  <div
    :dependentComputedProps="{
      isSessionPresent,
    }"
  ></div>
</template>

<script>
import {
  keyMapsAction,
  keyMapsMutation,
  keyMapsGetter,
} from "../helpers/storeKeys";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { initializeMoEngageTime } from "../helpers/moengageEvents";
import {
  loadAmplitudeUnsentEvents,
  EVENT_PAGEVIEW_OFFERSPAGE,
} from "../helpers/analyticsEvents";
import { getVwoExperimentsPromiseArray } from "../helpers/vwoSetup";
// import { VWO_HOMEPAGE_EXPERIMENT } from "../config/vwoKeys";
import Utility from "../helpers/utility";
import { initializeMetaTime } from "../helpers/metaEvents";

export default {
  name: "InitializeOffers",
  components: {},
  data() {
    return {
      sessionDependedMethodsProcessed: false,
    };
  },
  async mounted() {
    this.$store.commit(
      keyMapsMutation.UPDATE_LOADING_STATE,
      false
    );

    // let fetchedVwoData = {};
    // await Promise.all([...getVwoExperimentsPromiseArray()])
    //   .then((data) => {
    //     data.forEach((element) => {
    //       for (let key in element) {
    //         fetchedVwoData[key] = element[key];
    //       }
    //     });
    //     this.$store.commit(
    //       keyMapsMutation.UPDATE_VWO_EXPERIMENTS,
    //       fetchedVwoData
    //     );
    //   })
    //   .catch((errors) => {});

    loadAmplitudeUnsentEvents();

    if (!LocalStorageFunc.accessToken()) {
      this.$store.dispatch(keyMapsAction.ANONYMOUS_USER_API, {});
    }
    setTimeout(() => {
      initializeMoEngageTime();
      initializeMetaTime();
    }, 5000);

    Utility.osBackButtonFunc();
    EVENT_PAGEVIEW_OFFERSPAGE();
  },
  methods: {},
  computed: {
    isSessionPresent() {
      let isSessionP = this.$store.state.Auth.isSessionPresent;
      if (
        isSessionP &&
        !this.sessionDependedMethodsProcessed &&
        LocalStorageFunc.isLoggedIn()
      ) {
        this.sessionDependedMethodsProcessed = true;
      }
      return isSessionP;
    },
  },
};
</script>
